import { connect } from "react-redux";
import AboutPopoto from "../../components/project-pages/AboutPopoto";

export default connect(
  (state, props) => ({}),
  (dispatch, props) => ({})
)(AboutPopoto);
